import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDeleteKeyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19.2 3.6H15.86C15.86 3.6 15.86 3.55 15.86 3.53C15.28 1.9 13.73 0.800003 12.01 0.800003C10.29 0.800003 8.74 1.9 8.16 3.53C8.16 3.55 8.16 3.57 8.16 3.6H4.82C4.16 3.6 3.62 4.14 3.62 4.8V7.2C3.62 7.53 3.89 7.8 4.22 7.8H19.82C20.15 7.8 20.42 7.53 20.42 7.2V4.8C20.42 4.14 19.88 3.6 19.22 3.6H19.2ZM12 1.8C13.2 1.8 14.28 2.52 14.79 3.6H9.21C9.71 2.52 10.8 1.8 12 1.8Z"
        fill={color}
      />
      <path
        d="M5.95003 22.25C5.98003 22.56 6.24003 22.8 6.55003 22.8H17.45C17.76 22.8 18.02 22.56 18.05 22.25L19.17 8.85001H4.84003L5.96003 22.25H5.95003ZM14.98 11.95C15.01 11.61 15.32 11.36 15.65 11.38C15.99 11.41 16.25 11.71 16.22 12.05L15.62 19.25C15.59 19.58 15.32 19.82 15 19.82C14.98 19.82 14.96 19.82 14.95 19.82C14.61 19.79 14.35 19.49 14.38 19.15L14.98 11.95ZM11.38 12C11.38 11.65 11.66 11.38 12 11.38C12.34 11.38 12.62 11.66 12.62 12V19.2C12.62 19.54 12.34 19.82 12 19.82C11.66 19.82 11.38 19.54 11.38 19.2V12ZM8.35003 11.38C8.70003 11.35 9.00003 11.61 9.02003 11.95L9.62003 19.15C9.65003 19.49 9.39003 19.8 9.05003 19.82C9.03003 19.82 9.01003 19.82 9.00003 19.82C8.68003 19.82 8.40003 19.57 8.38003 19.25L7.78003 12.05C7.75003 11.71 8.01003 11.4 8.35003 11.38Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDeleteKeyIcon.displayName = 'TimeDeleteKeyIcon';
